import { Notifier } from '@airbrake/browser';
import { environment } from '@environment';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AirbrakeService {
  private airbrake: Notifier;
  private env = environment.envName;

  constructor() {
    this.airbrake = new Notifier({
      projectId: environment.airbrake.projectId,
      projectKey: environment.airbrake.projectKey,
      environment: this.env,
    });
  }

  public errorHandler(error: unknown): void {
    if (['local'].includes(this.env)) {
      console.error(error);
    } else if (['dev'].includes(this.env)) {
      console.error(error);
      this.airbrake.notify(error);
    } else {
      this.airbrake.notify(error);
    }
  }

  notifyAirbrake(error: unknown, context?: Record<string, unknown>): void {
    if (['dev', 'prod'].includes(this.env)) {
      this.airbrake.notify({
        error,
        params: context,
      });
    }
  }
}
